import { useNavigate } from 'react-router';

import { CasDisplayField, CasErrorDisplay, CasStackRow } from 'src/compass/shared/components';
import CasRefreshButton from 'src/compass/shared/components/CasButton/CasRefreshButton';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import { ClaimStatusFilter_NotDoneOrAttached } from '../shared/ClaimListing/ClaimListing';

export default function DashboardTab() {
  const queryResult = useRetrieve({ url: 'Sce/Claims/Dashboard' });
  const navigate = useNavigate();

  const { data, isFetching, isError, refetch } = queryResult;

  if (isFetching) return <CasLoader />;

  if (isError) return <CasErrorDisplay message="Error retrieving data from the server." />;

  const {
    noticeMissingCount,
    reviewUploadsCount,
    sendCount,
    docusignReviewCount,
    callbackCount,
    daysLeftCount,
    numberOfDaysLeft,
  } = data;

  const baseUrl = '/endorsements/claimtracking';

  return (
    <CasStackRow alignItems="center">{/* Temporary for now to remove CasDisplayField margin-bottom */}
      <div>
        <CasDisplayField
          horizontal 
          label="Notice Missing"
          value={noticeMissingCount}
          onClick={() => navigate(`${baseUrl}/entry/noticeMissing`)}
        />
        <CasDisplayField
          horizontal 
          label="Review Uploads"
          value={reviewUploadsCount}
          onClick={() => navigate(`${baseUrl}/entry/fwdContracts/review`)}
        />
        <CasDisplayField
          horizontal
          label="Send"
          value={sendCount}
          onClick={() => navigate(`${baseUrl}/entry/send`)}
        />
        <CasDisplayField
          horizontal
          label="Docusign Review"
          value={docusignReviewCount}
          onClick={() => navigate(`${baseUrl}/entry/docusignReview`)}
        />
        <CasDisplayField
          horizontal
          label="Callback"
          value={callbackCount}
          onClick={() => navigate(`${baseUrl}/entry/callback`)}
        />
        <CasDisplayField
          horizontal
          label={`${numberOfDaysLeft} days or less left to sign`}
          value={daysLeftCount}
          onClick={() =>
            navigate(
              `${baseUrl}/search?${new URLSearchParams({
                daysLeftLessThan: numberOfDaysLeft,
                status: ClaimStatusFilter_NotDoneOrAttached,
              })}`
            )
          }
        />
        <CasDisplayField
          horizontal
          label="Rejected Claims"
          value
          onClick={() =>
            navigate(
              `${baseUrl}/search?${new URLSearchParams({
                rejected: 'true',
              })}`
            )
          }
        />

        <CasRefreshButton refetch={refetch} />
      </div>
    </CasStackRow>
  );
}
